import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import AdminGroupAccountCampersJoinedList from "./AdminGroupAccountCampersJoinedList.js";
import '../Styles/AdminGroupAccountReservationCard.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js";



function AdminGroupAccountReservationCard({ reservation }) {

   const [campersJoined, setCampersJoined] = useState();
   const [camperJoinedVisibility, setCampersJoinedVisibility] = useState(false)
   const getRegistrationsForReservation = async () => {
      try {

         // Get Transactions
         var groupCode = reservation.group_code
         const defaultTransactions = await fetch('/individualsjoined', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               groupCode
            })
         })
         var response = await defaultTransactions.json()
         console.log("here's registrations", response)
         setCampersJoined(response.data.selectedRegistrations)
      } catch (error) {

      }
   }
   return (
      <div className="AdminGroupAccountReservationCardContainer">
         <div className="AdminGroupAccountReservationCardRowOne">
            <div className="AdminGroupAccountReservationCardRowOneItemTitle">
               {reservation.camp_name}
            </div>
            <div className="AdminGroupAccountReservationCardRowOneItem">
               {DateHelpers.getEventDateRange(reservation.begin_date, reservation.end_date)}
            </div>
            <div className="AdminGroupAccountReservationCardRowOneItem">
               {reservation.is_fast_track === true ? "Fast Track" : "Standard"}
            </div>
         </div>
         <div className="AdminGroupAccountReservationCardRowTwo">
            <div className="AdminGroupAccountReservationCardRowTwoItem">
               <button onClick={() => {
                  getRegistrationsForReservation()
                  setCampersJoinedVisibility(!camperJoinedVisibility)
               }}>
                  Campers Joined
               </button>
            </div>
            <div className="AdminGroupAccountReservationCardRowTwoItem">
               Group Code:{reservation.group_code}
            </div>
            <div className="AdminGroupAccountReservationCardRowTwoItem">
               Estimated Count: {reservation.num_spots_reserved}
            </div>
         </div>
         {camperJoinedVisibility && (
            campersJoined?.length > 0 ? (
               <AdminGroupAccountCampersJoinedList
                  campersJoined={campersJoined}
               />
            ) : (
               <div>No campers have joined this group.</div>
            )
         )}
      </div>
   )
}
export default AdminGroupAccountReservationCard